import api from "@/lib/axiosConfig";
import { z, ZodType } from "zod";
import { baseRoute } from "./audiovisual";

export const audiovisualSchema = z.object({
  id: z.string().optional(),
  audiovisuelDescriptionNumeroEnregistrement: z
    .string()
    .nonempty("form.error.emptyField"),
  audiovisuelDescriptionTitre: z.string(),
});

export const appendNoDuplicateRecordNumberRefine = <
  T extends {
    id?: string;
    audiovisuelDescriptionNumeroEnregistrement: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.audiovisuelDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.audiovisual.duplicateRecordNumbers",
      path: ["audiovisuelDescriptionNumeroEnregistrement"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  exhibitionNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/record-number/validate/no-duplicates`, {
    params: {
      value: exhibitionNumber,
      id,
    },
  });
}
